import { render, staticRenderFns } from "./BatchCreated.vue?vue&type=template&id=bb2fb5c8&scoped=true&"
import script from "./BatchCreated.vue?vue&type=script&lang=js&"
export * from "./BatchCreated.vue?vue&type=script&lang=js&"
import style0 from "./BatchCreated.vue?vue&type=style&index=0&id=bb2fb5c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2fb5c8",
  null
  
)

export default component.exports